module.exports = __webpack_public_path__ + "img/schoolBj.549c1c5c.png";